import { render, staticRenderFns } from "./SuggestionPage3.vue?vue&type=template&id=51d5796a"
import script from "./SuggestionPage3.vue?vue&type=script&lang=js"
export * from "./SuggestionPage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports